'use client'

import { createFormHook } from '@tanstack/react-form'

import {
  CheckboxField,
  OtpField,
  PasswordField,
  PhoneField,
  SwitchField,
  TextField,
} from './fields'
import { fieldContext, formContext } from './formContext'
import { FormError } from './FormError'
import { SubmitButton } from './SubmitButton'

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    PasswordField,
    PhoneField,
    OtpField,
    CheckboxField,
    SwitchField,
  },
  formComponents: {
    SubmitButton,
    FormError,
  },
})
